const Heading = ({ title, description }) => (
  <div className="mb-5">
    <p className="text-base font-bold text-secondary-900">{title}</p>
    <p className="mt-1 text-sm text-secondary-500">{description}</p>
  </div>
);

export default Heading;
